import Reports from "../pages/reports/Reports";
import { userRoles as ur } from "../../assets/const/userRole";



export const reportRoutes=[
    
    {
        path: '/reports/supply-partner',
        field:"supply-partner",
        label:'Supply Partner',
        element: <Reports/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/reports/supply',
        field:"supply",
        label:'Supply',
        element:  <Reports/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/reports/demand-partner',
        field:"demand-partner",
        label:"Demand Partner",
        element:  <Reports/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },

    {
        path: '/reports/demand',
        field:"demand",
        label:"Demand",
        element:  <Reports/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/reports/routes',
        field:"routes",
        label:"Routes",
        element: <Reports/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_REPORT,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
   
]